module.exports = __webpack_public_path__ + "static/media/notifications.3ccb8e86.gif";